module.exports = __webpack_public_path__ + "static/media/landing-bg.e9dee849.jpg";